import React from 'react'
import { Typography } from '@ann/web-components'

const SearchResults = ({ searchQuery, count, type }) => (
    <Typography
        category="body"
        size="small"
        weight="regular"
        style={{ marginBottom: '16px', color: '#666' }}
    >
        {count} {type}{count !== 1 ? 's' : ''} found for "{searchQuery}"
    </Typography>
)

export default SearchResults
